export const appVersion = '1.0.5'
